import { forwardRef, useCallback, useImperativeHandle, useState } from "react";
import classNames from "classnames";
import { editIcon, checkBlackIcon } from "../../assets/icons";

const ToggleRenderer = forwardRef(function ToggleRenderer(props, ref) {
  const [isToggled, setIsToggled] = useState(props.value);

  useImperativeHandle(ref, () => {
    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        return isToggled;
      },
    };
  });

  const handleOnClick = useCallback(
    () => setIsToggled(!isToggled),
    [isToggled]
  );

  return (
    <div className="group flex w-full h-full items-center">
      <div
        onClick={props.cellStartedEdit && handleOnClick}
        className={classNames(
          "m-auto w-11 h-6 relative bg-gray-700 rounded-full after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all",
          {
            "after:translate-x-full !bg-emerald-500 after:border-white":
              isToggled,
          }
        )}
      />
      <img
        src={editIcon}
        alt="edit-icon"
        className={classNames(
          "absolute right-2 top-3 hidden group-hover:block w-4 h-4 group-hover:cursor-pointer",
          { hidden: props.cellStartedEdit }
        )}
      />
      <img
        src={checkBlackIcon}
        alt="check-icon"
        className={classNames("absolute right-2 top-3 w-4 h-4 cursor-pointer", {
          hidden: !props.cellStartedEdit,
        })}
        onClick={() => props.api.stopEditing()}
      />
    </div>
  );
});

export default ToggleRenderer;
